import { StrictMode, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import { AlertProvider, AuthProvider, KmstackProvider, BrowserWebSocketProvider } from 'kmstack-shared/providers';
import { TrackingProvider } from 'kmstack-shared/tracking';
import { initEnv } from 'kmstack-shared/core'

import { store, persistor } from './store'
import App from './App'
import { applyThemeColors } from './styles/theme'
import './index.css'
import './styles/checkbox.css'
import { UIProvider } from '@/context/UIContext'


applyThemeColors();
initEnv(import.meta.env);

function Root() {
  const [queryClient] = useState(() => new QueryClient())

  return (
    <StrictMode>
      <AlertProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor!}>
            <KmstackProvider dispatch={store.dispatch} getState={() => store.getState()}>
                {/* TODO: this should be improved so that it not making an api call on every refresh */}
                <TrackingProvider types={['geo']}>
                  <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                      <BrowserWebSocketProvider>
                        <BrowserRouter>
                          <UIProvider>
                            <App />
                          </UIProvider>
                        </BrowserRouter>
                      </BrowserWebSocketProvider>
                    </AuthProvider>
                  </QueryClientProvider>
                </TrackingProvider>
            </KmstackProvider>
          </PersistGate>
        </Provider>
      </AlertProvider>
    </StrictMode>
  )
}

createRoot(document.getElementById('root')!).render(<Root />)
